import { UserAutoCompleteValueType } from '@nimbus-library/features/shared/services/user-search/models/user-auto-complete-value-type';
import { IdentifierType } from '../../enums/identifier-type';

export class IdentifierTypeMapper {
  public static map(source: UserAutoCompleteValueType): IdentifierType {
    switch (source) {
      case UserAutoCompleteValueType.GUID:
        return IdentifierType.Guid;
      case UserAutoCompleteValueType.PSTN:
        return IdentifierType.Pstn;
      default:
        return IdentifierType.Guid;
    }
  }
}
